import { PersonalizationClient } from '@atc/personalization-client';
import { Duck } from '@atc/modular-redux';

// Selectors
import selectors from './savedInventoryDuckSelectors';
import reducer from './savedInventoryDuckReducer';
import creators from './savedInventoryDuckCreators/index.js';
const defaultState = {
  inventory: [],
  updateSavedInventory: {
    listing: null,
    bookmark: {
      id: null,
      isSaved: null,
      isExisting: null,
      title: null
    },
    phone: null,
    context: 'update',
    messages: null
  },
  recommendedInventory: [],
  maxQuickSavesLimit: 0,
  animatedButtonState: ''
};

// export personalization only for testing
// eslint-disable-next-line import/no-mutable-exports
export let personalization;
export default function savedInventoryDuckCreator(_temp) {
  let {
    namespace = '',
    store = 'savedInventory',
    storePath,
    inventoryDuck,
    authDuck,
    initialState = {},
    env = 'qa',
    ...rest
  } = _temp === void 0 ? {} : _temp;
  personalization = new PersonalizationClient({
    env
  });
  return new Duck({
    ...rest,
    namespace,
    store,
    storePath,
    initialState: {
      ...defaultState,
      ...initialState
    },
    consts: {},
    types: ['ADD_SAVED_INVENTORY_ITEM', 'REMOVE_SAVED_INVENTORY_ITEM', 'SHOW_QUICK_SAVE_NOTIFICATION', 'HIDE_QUICK_SAVE_NOTIFICATION', 'SET_MAX_QUICK_SAVES_LIMIT', 'SET_SAVED_INVENTORY_ITEMS', 'SET_SAVED_INVENTORY_ITEM_BY_INDEX', 'CLEAR_SAVED_INVENTORY', 'SET_UPDATE_SAVED_INVENTORY_STATE', 'SHOW_UPDATE_SAVED_INVENTORY', 'SET_GLOBAL_ALERT', 'CLEAR_GLOBAL_ALERT', 'HIDE_UPDATE_SAVED_INVENTORY', 'UPDATE_SAVED_INVENTORY',
    // update animated button state
    'SET_ANIMATED_BUTTON_STATE'],
    creators: duck => creators(duck, authDuck, personalization, inventoryDuck),
    reducer,
    selectors: selectors()
  });
}